import { Component, Input, OnInit } from '@angular/core';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { UploadPhotoModel } from 'src/app/models/upload-photo-model';
import { CompanyLogoComponentStore } from 'src/app/stores/components/company-logo/company-logo.component-store';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyModel } from 'src/app/models/company-model';
@Component({
    selector: 'app-company-logo',
    templateUrl: './company-logo.component.html',
    styleUrls: ['./company-logo.component.scss'],
    standalone: false
})
export class CompanyLogoComponent implements OnInit {
  readonly max_size = 538 * 1024;
  readonly allowed_types = ['image/png', 'image/jpeg'];
  readonly min_height = 512;
  readonly min_width = 512;
  readonly max_height = 512;
  readonly max_width = 512;
  readonly placeholderUrl = '/assets/img/placeholder.png';

  @Input()
  company: CompanyModel;

  ngUnsubscribeState = new Subject<void>();

  isImageSaved: boolean;

  companyLogoUrl$ : Observable<string>;

  constructor(private companyLogoComponentStore: CompanyLogoComponentStore,
    private snackBar: MatSnackBar
    ) {
    // Do nothing
  }

  ngOnInit(): void {
    this.companyLogoComponentStore.logo$.pipe(takeUntil(this.ngUnsubscribeState)).subscribe(logo => {
      this.snackBar.dismiss();
      if(logo !== null && logo !== undefined){
        this.isImageSaved = true;
        this.companyLogoUrl$ = of(logo.url);
      }
      else {
        this.isImageSaved = false;
        this.companyLogoUrl$ = of(this.placeholderUrl);
        if(this.company){
          this.snackBar.open('Please upload a company logo.', 'Dismiss');
        }
      }
    });
  }

  ngOnDestroy(){
    this.ngUnsubscribeState.next();
    this.ngUnsubscribeState.complete();
  }

  ngOnChanges(changes){
    if(changes.company && this.company){
      this.companyLogoComponentStore.getCompanyLogo({companyId : this.company.id });  
    }
  }

  fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.max_size) {
        var errorMessage =
          'Maximum size allowed is ' + Math.floor(this.max_size / 1000) + 'Kb';
          this.snackBar.open(errorMessage, "Dismiss");
        return false;
      }

      if (!_.includes(this.allowed_types, fileInput.target.files[0].type)) {
        var errorMessage = 'Only Images are allowed ( JPG | PNG )';
        this.snackBar.open(errorMessage, "Dismiss");
        return false;
      }

      var uploadPhoto = new UploadPhotoModel();

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];
          if (img_height > this.max_height || img_width > this.max_width) {
            const errorMessage =
              'Dimensions required ' +
              this.max_height +
              '*' +
              this.max_width +
              'px';
            this.snackBar.open(errorMessage, "Dismiss");
            return false;
          } 
          else if (img_height < this.min_height || img_width < this.min_width) {
            const errorMessage =
              'Dimensions required ' +
              this.min_height +
              '*' +
              this.min_width +
              'px';
            this.snackBar.open(errorMessage, "Dismiss");
            return false;
          } else {
            const imgBase64Path = e.target.result;            
            uploadPhoto.fileContentBase64 = imgBase64Path.split(',')[1];
            this.companyLogoComponentStore.uploadCompanyLogo({ companyId: this.company.id, uploadPhoto: uploadPhoto });

            return true;
          }
        };
      };

      var logo = fileInput.target.files[0];

      uploadPhoto.title = 'Company Logo';
      uploadPhoto.fileName = 'logo' + this._determineFileExtension(logo.type);

      reader.readAsDataURL(logo);
      return true;
    }
    return true;
  }

  removeImage() {
    this.companyLogoComponentStore.deleteCompanyLogo({companyId: this.company.id});
  }

  _determineFileExtension(fileType: string): string {
    switch (fileType) {
      case 'image/jpg':
      case 'image/jpeg':
        return '.jpg';
      case 'image/png':
        return '.png';
    }
    throw new Error('Unsupported file type:' + fileType);
  }
}
